import React from 'react'
import FeatherIcon from 'feather-icons-react'
import objectPath from 'object-path'

const IconDisplay = ({ menu }) => {
  let iconType = objectPath.get(menu, 'iconType')
  let iconSource = objectPath.get(menu, 'iconSource')
  let iconColor = objectPath.get(menu, 'iconColor')
  let iconTextColor = objectPath.get(menu, 'iconTextColor')
  let icon = objectPath.get(menu, 'icon')

  return (
    <>
      {iconType === 'icon' && iconSource === 'ckd' && (
        <i
          className={`ckd-icon ckd-${icon} mr-1`}
          style={{
            color: iconColor,
            margin: 0,
            fontSize: '18px',
          }}
        ></i>
      )}
      {iconType === 'icon' && iconSource === 'feather' && (
        <FeatherIcon
          className="mr-1"
          style={{
            color: iconColor,
          }}
          icon={icon || 'menu'}
          size="18"
        />
      )}
      {iconType === 'icon' && iconSource === 'fas' && (
        <i
          className={`fas fa-${icon} mr-1`}
          style={{
            fontSize: '18px',
            color: iconColor,
          }}
        />
      )}
      {iconType === 'icon' && iconSource === 'healthicons' && (
            <i className={`healthicons-${icon}-outline`} style={{color:iconColor,fontSize:'24px'}}></i>
      )}
      {iconType === 'char' && (
        <i
          className="ck-badge d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: iconColor,
            color: iconTextColor,
            fontSize: '16px',
            textAlign: 'center',
            fontStyle: 'normal',
          }}
        >
          {objectPath.get(menu, 'iconText')}
        </i>
      )}
    </>
  )
}

export default IconDisplay
